import React from 'react';
import Button from '../components/ui/Button';
import { Link } from 'react-router-dom';

const Sobre: React.FC = () => {
  return (
    <div className="py-12">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Sobre Nós</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Conheça a Aristia e nossa trajetória de excelência
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-2xl font-bold mb-4">Nossa História</h2>
            <p className="text-gray-600 mb-4">
              A Aristia Consultoria nasceu da paixão pela excelência e da convicção de que processos bem estruturados são a base para o crescimento sustentável de qualquer organização. 
              O nome Aristia, de origem grega, representa
               “o melhor” e “o mais notável” — valores que traduzem nosso compromisso com a excelência técnica e a entrega de soluções de alto impacto.
            </p>
            <p className="text-gray-600 mb-4">
              A Aristia Consultoria é liderada por Patricia G. Siqueira, profissional com mais de 15 anos de experiência em indústrias de diversos segmentos — incluindo papel, gases nobres, alimentos e tecnologia. 
              Essa vivência prática e multidisciplinar garante uma abordagem técnica, personalizada e alinhada aos requisitos das normas ISO 9001, ISO 14001, ISO 45001 e ISO 27001.
            </p>
            <p className="text-gray-600">
              ​

Ao longo da nossa trajetória, construímos uma reputação sólida, pautada em resultados comprovados, entregas de alto valor e relacionamentos duradouros com nossos clientes.​

Atuamos com abordagem personalizada, foco em melhoria contínua e compromisso com a excelência em gestão — sempre guiados pelo espírito de Aristia.
            </p>
          </div>
          <div className="bg-gray-100 p-8 rounded-lg">
            <h2 className="text-2xl font-bold mb-4">Nossa Missão</h2>
            <p className="text-gray-600 mb-6">
              Impulsionar a transformação organizacional por meio da implementação de sistemas de gestão da qualidade eficazes, personalizados e alinhados à realidade de cada cliente. 
              Promovendo a melhoria contínua, a excelência operacional e a geração de valor sustentável.
            </p>
            <h2 className="text-2xl font-bold mb-4">Nossa Visão</h2>
            <p className="text-gray-600 mb-6">
              Ser reconhecida nacionalmente como referência em consultoria de sistemas de gestão, contribuindo para o desenvolvimento sustentável das organizações e para a consolidação da cultura da qualidade em todos os setores da economia brasileira.
            </p>
            <h2 className="text-2xl font-bold mb-4">Nossos Valores</h2>
            <ul className="list-disc list-inside text-gray-600">
              <li>Excelência em tudo o que fazemos</li>
              <li>Integridade e transparência nas relações e entregas</li>
              <li>Compromisso com resultados reais e mensuráveis</li>
              <li>Inovação e melhoria contínua como pilares da evolução</li>
              <li>Valorização das pessoas e do conhecimento</li>
            </ul>
          </div>
        </div>

        

        <div className="bg-primary text-white p-8 rounded-lg text-center">
          <h2 className="text-2xl font-bold mb-4">Vamos trabalhar juntos?</h2>
          <p className="text-lg mb-6 max-w-2xl mx-auto">
            Entre em contato conosco para uma conversa inicial e descubra como podemos 
            ajudar sua empresa a alcançar a excelência em gestão da qualidade.
          </p>
          <Link to="/contato">
            <Button variant="outline" className="border-white text-white hover:bg-white/20">
              Entre em contato
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Sobre;
